<template>
  <section>
    <template>
      <b-row>
        <b-col cols="12" md="8">
          <b-col cols="12">
            <b-card>
              <b-row>
                <b-col cols="12">
                  <b-card>
                    <b-row>
                      <b-col md="10" lg="10" xs="12">
                        <b-badge
                          class="mb-2"
                          v-b-tooltip.hover.top="'Board Name'"
                          variant="light-primary"
                        >
                          {{ task?.milestoneTaskBoard?.data?.title }}
                        </b-badge>

                        <!--                        <b-breadcrumb class="breadcrumb-chevron pl-0">-->
                        <!--                          <template v-if="task?.title">-->
                        <!--                            <b-breadcrumb-item v-on:click="onShowBoardDetails" active>-->
                        <!--                              {{ task?.milestoneTaskBoard?.data?.title }}-->
                        <!--                            </b-breadcrumb-item>-->
                        <!--                          </template>-->
                        <!--                        </b-breadcrumb>-->
                        <template v-if="task?.title">
                          <div>
                            <b-card-text>
                              <h2>
                                {{ task?.title }}
                                <feather-icon
                                  icon="CopyIcon"
                                  @click="copyUrlToClipboard"
                                />
                              </h2>
                              <span
                                v-if="showCopiedMessage"
                                class="copied-message"
                              >
                                <b-badge variant="success" class="badge-glow">
                                  Link Copied!
                                </b-badge>
                              </span>
                            </b-card-text>
                          </div>
                        </template></b-col
                      >
                      <template
                        v-if="
                          $permissionAbility(
                            MILESTONE_BOARD_TASK_EDIT,
                            permissions
                          )
                        "
                      >
                        <b-col md="2" lg="2" xs="12">
                          <span class="d-flex justify-content-end">
                            <b-button
                              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                              variant="primary"
                              class="btn btn-sm"
                              v-on:click="showTaskModal(task)"
                            >
                              <feather-icon icon="EditIcon" class="mr-50" />
                              <span class="align-middle">Edit</span>
                            </b-button>
                          </span>
                        </b-col>
                      </template>
                    </b-row>
                    <b-row class="mt-1">
                      <b-col md="12" lg="12" xs="12">
                        <template
                          v-if="
                            $permissionAbility(
                              MILESTONE_BOARD_SUB_TASK_CREATE,
                              permissions
                            )
                          "
                        >
                          <b-button
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                            variant="primary"
                            class="btn btn-sm mr-1"
                            v-on:click="showSubTaskForm"
                          >
                            <feather-icon icon="BriefcaseIcon" class="mr-50" />
                            Add Sub Task
                          </b-button>
                        </template>

                        <b-button
                          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                          variant="primary"
                          v-on:click="showTaskLinkForm"
                          class="btn-sm"
                        >
                          <feather-icon icon="LinkIcon" class="mr-50" />
                          Link Task
                        </b-button>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="12">
                        <div class="mt-2">
                          <template v-if="task?.description">
                            <h5 class="text-capitalize">Description:</h5>

                            <b-card-text>
                              <div v-html="task?.description"></div>
                            </b-card-text>
                          </template>
                        </div>
                      </b-col>

                      <template v-if="isSubTaskFormLoaded">
                        <b-col md="12" lg="12" xs="12" class="mt-1 mb-1">
                          <validation-observer ref="subTaskAdd">
                            <b-form v-on:submit.prevent="subTaskAddForm">
                              <b-row
                                ><b-col md="8" lg="8" xs="12">
                                  <ValidationProvider
                                    name="sub task title"
                                    v-slot="{ errors }"
                                    vid="title"
                                    rules="required"
                                  >
                                    <b-form-input
                                      id="title"
                                      type="text"
                                      class="custom-font"
                                      v-model="subTaskTitle"
                                      :state="errors.length > 0 ? false : null"
                                      placeholder="Enter Sub Task Title"
                                    />
                                    <small class="text-danger">{{
                                      errors[0]
                                    }}</small>
                                  </ValidationProvider>
                                </b-col>
                                <b-col md="4" lg="4" xs="12">
                                  <template v-if="isSubTaskLoading">
                                    <b-button
                                      class="float-right"
                                      variant="primary"
                                      disabled
                                    >
                                      <b-spinner small />
                                      Loading...
                                    </b-button> </template
                                  ><template v-else>
                                    <b-button
                                      class="float-right btn-sm"
                                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                      variant="primary"
                                      v-on:click="closeSubTaskForm"
                                    >
                                      Cancel
                                    </b-button>
                                    <b-button
                                      type="submit"
                                      class="float-right mr-1 btn-sm"
                                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                      variant="primary"
                                    >
                                      Add
                                    </b-button>
                                  </template>
                                </b-col>
                              </b-row>
                            </b-form>
                          </validation-observer>
                        </b-col>
                      </template>
                      <b-col
                        v-if="subTaskList.length > 0"
                        md="12"
                        lg="12"
                        xs="12"
                        class="mb-1"
                      >
                        <h5>
                          {{ subTaskList.length > 0 ? "Sub Task List:" : "" }}
                        </h5>

                        <div class="sequencial-sub-task-list">
                          <draggable
                            :list="sequencetialSubTaskList"
                            tag="ul"
                            class="list-group list-group-flush cursor-move"
                            @end="onSequenceChange"
                          >
                            <b-list-group-item
                              class="d-flex justify-content-between align-items-center"
                              v-for="(
                                subTask, index
                              ) in sequencetialSubTaskList"
                              :key="index"
                              tag="li"
                            >
                              <b-link
                                v-on:click="
                                  onShowSubTask(
                                    task?.milestoneTaskBoard?.data?.id,
                                    task.id,
                                    task.short_title,
                                    subTask?.id,
                                    subTask?.short_title
                                  )
                                "
                              >
                                <b-badge variant="light-warning">{{
                                  index + 1
                                }}</b-badge>
                                {{ subTask?.title }}
                              </b-link>

                              <div
                                class="custom-search d-flex align-items-center justify-content-end"
                              >
                                <b-badge
                                  v-if="subTask?.id == nextTask?.id"
                                  variant="light-danger"
                                  class="mr-1"
                                >
                                  Up Next
                                </b-badge>
                                <template v-if="subTask?.is_completed">
                                  <b-badge
                                    variant="light-success"
                                    class="mr-1"
                                    >{{ subTask?.phase?.data?.title }}</b-badge
                                  >
                                </template>
                                <template v-else>
                                  <b-badge
                                    variant="light-primary"
                                    class="mr-1"
                                    >{{ subTask?.phase?.data?.title }}</b-badge
                                  >
                                </template>

                                <template
                                  v-if="
                                    $permissionAbility(
                                      MILESTONE_BOARD_SUB_TASK_EDIT,
                                      permissions
                                    )
                                  "
                                >
                                  <b-dropdown
                                    no-caret
                                    class="mr-1 btn-sm"
                                    :variant="
                                      subTask?.sequence_num
                                        ? 'outline-warning'
                                        : 'outline-primary'
                                    "
                                    :text="
                                      subTask?.sequence_num
                                        ? 'Sequential'
                                        : 'General'
                                    "
                                    :disabled="subTask?.is_completed"
                                    style="padding: 0"
                                  >
                                    <b-dropdown-item
                                      v-on:click="resetToGeneral(subTask?.id)"
                                    >
                                      Reset
                                    </b-dropdown-item>
                                  </b-dropdown>
                                </template>

                                <template
                                  v-if="
                                    $permissionAbility(
                                      MILESTONE_BOARD_SUB_TASK_DELETE,
                                      permissions
                                    )
                                  "
                                >
                                  <b-button
                                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                    variant="danger"
                                    class="btn-sm"
                                    v-on:click="onDeleteSubTask(subTask?.id)"
                                  >
                                    <feather-icon icon="TrashIcon" />
                                  </b-button>
                                </template>
                              </div>
                            </b-list-group-item>
                          </draggable>
                        </div>

                        <b-list-group>
                          <br />
                          <b-list-group-item
                            class="d-flex justify-content-between align-items-center"
                            v-for="subTask in generalSubTaskList"
                            :key="subTask?.id"
                            tag="li"
                          >
                            <b-link
                              v-on:click="
                                onShowSubTask(
                                  task?.milestoneTaskBoard?.data?.id,
                                  task.id,
                                  task.short_title,
                                  subTask?.id,
                                  subTask?.short_title
                                )
                              "
                            >
                              {{ subTask?.title }}
                              <template v-if="subTask?.sequence_num > 0">
                                <b-badge class="ml-1" variant="light-warning">
                                  {{ subTask?.sequence_num }}
                                </b-badge>
                              </template></b-link
                            >

                            <div
                              class="custom-search d-flex align-items-center justify-content-end"
                            >
                              <template v-if="subTask?.is_completed">
                                <b-badge variant="light-success" class="mr-1">{{
                                  subTask?.phase?.data?.title
                                }}</b-badge>
                              </template>
                              <template v-else>
                                <b-badge variant="light-primary" class="mr-1">{{
                                  subTask?.phase?.data?.title
                                }}</b-badge>
                              </template>

                              <template
                                v-if="
                                  $permissionAbility(
                                    MILESTONE_BOARD_SUB_TASK_EDIT,
                                    permissions
                                  )
                                "
                              >
                                <b-dropdown
                                  no-caret
                                  class="mr-1 btn-sm"
                                  :variant="
                                    subTask?.sequence_num
                                      ? 'outline-warning'
                                      : 'outline-primary'
                                  "
                                  :text="
                                    subTask?.sequence_num
                                      ? 'Sequential'
                                      : 'General'
                                  "
                                  :disabled="subTask?.is_completed"
                                  style="padding: 0"
                                >
                                  <template>
                                    <b-dropdown-item
                                      v-on:click="updateSequence(subTask)"
                                      >Set As Sequential
                                    </b-dropdown-item>
                                  </template>
                                </b-dropdown>
                              </template>

                              <template
                                v-if="
                                  $permissionAbility(
                                    MILESTONE_BOARD_SUB_TASK_DELETE,
                                    permissions
                                  )
                                "
                              >
                                <b-button
                                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                  variant="danger"
                                  class="btn-sm"
                                  v-on:click="onDeleteSubTask(subTask?.id)"
                                >
                                  <feather-icon icon="TrashIcon" />
                                </b-button>
                              </template>
                            </div>
                          </b-list-group-item>
                        </b-list-group>
                      </b-col>
                      <template v-if="isTaskLinkFormLoaded">
                        <b-col md="12" lg="12" xs="12" class="mt-1 mb-1">
                          <validation-observer ref="taskLinkAdd">
                            <b-form v-on:submit.prevent="taskLinkAddForm">
                              <b-row
                                ><b-col md="8" lg="8" xs="12">
                                  <ValidationProvider
                                    name="task title"
                                    v-slot="{ errors }"
                                    vid="task_id"
                                    rules="required"
                                  >
                                    <v-select
                                      id="sub_task_title"
                                      placeholder="Search Task Here"
                                      class="custom-font"
                                      v-model="task_id"
                                      :options="tasksIdOption"
                                      label="name"
                                    />
                                    <small class="text-danger">{{
                                      errors[0]
                                    }}</small>
                                  </ValidationProvider>
                                </b-col>
                                <b-col md="4" lg="4" xs="12">
                                  <template v-if="isTaskLinkLoading">
                                    <b-button
                                      class="float-right"
                                      variant="primary"
                                      disabled
                                    >
                                      <b-spinner small />
                                      Loading...
                                    </b-button> </template
                                  ><template v-else>
                                    <b-button
                                      class="float-right btn-sm"
                                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                      variant="primary"
                                      v-on:click="closeTaskLinkForm"
                                    >
                                      Cancel
                                    </b-button>
                                    <b-button
                                      type="submit"
                                      class="float-right mr-1 btn-sm"
                                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                      variant="primary"
                                    >
                                      Add
                                    </b-button>
                                  </template>
                                </b-col>
                              </b-row>
                            </b-form>
                          </validation-observer>
                        </b-col>
                      </template>
                      <b-col
                        v-if="taskLinkList.length > 0"
                        md="12"
                        lg="12"
                        xs="12"
                        class="mb-2"
                      >
                        <h5>
                          {{
                            taskLinkList.length > 0 ? "Linked Task List:" : ""
                          }}
                        </h5>
                        <b-list-group>
                          <b-list-group-item
                            class="d-flex justify-content-between align-items-center"
                            v-for="taskList in taskLinkList"
                            :key="taskList?.id"
                          >
                            <b-link
                              v-on:click="onShowTask(taskList?.task_subtask_id)"
                            >
                              {{ taskList?.task_subtask_title }}
                            </b-link>

                            <div
                              class="custom-search d-flex align-items-center justify-content-end"
                            >
                              <b-button
                                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                variant="danger"
                                class="btn-sm"
                                v-on:click="onDeleteLinkTask(taskList?.id)"
                              >
                                <feather-icon icon="XCircleIcon" />
                              </b-button>
                            </div>
                          </b-list-group-item>
                        </b-list-group>
                      </b-col>
                    </b-row>

                    <!-- Attachment -->
                    <b-row>
                      <template v-if="taskDetailsPreviousFiles.length > 0">
                        <h5 class="text-capitalize">Attachment:</h5>
                        <b-row class="mb-2">
                          <b-col>
                            <div class="scrollable-file-container">
                              <div
                                class="uploaded-files mb-2 scrollable-file-content"
                              >
                                <div
                                  v-for="(
                                    item, index
                                  ) in taskDetailsPreviousFiles"
                                  :key="index"
                                  class="file-preview"
                                >
                                  <b-row class="mr-1">
                                    <b-col md="8" lg="8" xs="12">
                                      <div
                                        v-b-tooltip.hover.bottom="
                                          item.file_name
                                        "
                                      >
                                        <template
                                          v-if="isPreviousFileImage(item)"
                                        >
                                          <img
                                            :src="item?.original_url"
                                            alt="Preview"
                                            width="100"
                                            height="100"
                                          />
                                        </template>

                                        <template v-else>
                                          <svg
                                            width="100px"
                                            height="100px"
                                            viewBox="0 0 24 24"
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="#000000"
                                          >
                                            <g
                                              id="SVGRepo_bgCarrier"
                                              stroke-width="0"
                                            ></g>
                                            <g
                                              id="SVGRepo_tracerCarrier"
                                              stroke-linecap="round"
                                              stroke-linejoin="round"
                                            ></g>
                                            <g id="SVGRepo_iconCarrier">
                                              <title></title>
                                              <g id="Complete">
                                                <g id="F-File">
                                                  <g id="Text">
                                                    <g>
                                                      <path
                                                        d="M18,22H6a2,2,0,0,1-2-2V4A2,2,0,0,1,6,2h7.1a2,2,0,0,1,1.5.6l4.9,5.2A2,2,0,0,1,20,9.2V20A2,2,0,0,1,18,22Z"
                                                        fill="none"
                                                        id="File"
                                                        stroke="#000000"
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                        stroke-width="2"
                                                      ></path>
                                                      <line
                                                        fill="none"
                                                        stroke="#000000"
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                        stroke-width="2"
                                                        x1="7.9"
                                                        x2="16.1"
                                                        y1="17.5"
                                                        y2="17.5"
                                                      ></line>
                                                      <line
                                                        fill="none"
                                                        stroke="#000000"
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                        stroke-width="2"
                                                        x1="7.9"
                                                        x2="16.1"
                                                        y1="13.5"
                                                        y2="13.5"
                                                      ></line>
                                                      <line
                                                        fill="none"
                                                        stroke="#000000"
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                        stroke-width="2"
                                                        x1="8"
                                                        x2="13"
                                                        y1="9.5"
                                                        y2="9.5"
                                                      ></line>
                                                    </g>
                                                  </g>
                                                </g>
                                              </g>
                                            </g>
                                          </svg>
                                        </template>
                                      </div>
                                    </b-col>
                                    <b-col md="3" lg="3" xs="12">
                                      <b-button
                                        class="flex-shrink-0 btn-sm"
                                        v-ripple.400="
                                          'rgba(255, 255, 255, 0.15)'
                                        "
                                        variant="outline-primary"
                                        @click="onShowImage(item)"
                                      >
                                        <feather-icon icon="EyeIcon" />
                                      </b-button>
                                    </b-col>
                                  </b-row>
                                </div>
                              </div>
                            </div>
                          </b-col>
                        </b-row>
                      </template>
                    </b-row>
                  </b-card>
                </b-col>
              </b-row>
            </b-card>
          </b-col>

          <b-col cols="12">
            <b-card>
              <b-tabs>
                <b-tab title="Comments">
                  <div active class="comment-scrollable">
                    <b-card-text>
                      <b-row>
                        <b-col md="12" xl="12" class="mb-1">
                          <!-- comments -->
                          <template v-if="isShowCommentModal == false">
                            <div class="mx-2 my-1">
                              <b-form-input
                                id="type"
                                type="text"
                                placeholder="Add Comment...."
                                class="custom-font"
                                v-on:click="showCommentModal"
                                autocomplete="off"
                              />
                            </div>
                          </template>

                          <template
                            v-if="
                              taskEditClicked == false &&
                              isShowCommentModal == true
                            "
                          >
                            <div class="mt-1 mx-2">
                              <validation-observer
                                ref="addCommentFormValidation"
                              >
                                <b-form v-on:submit.prevent="addCommentForm">
                                  <b-form-group>
                                    <ValidationProvider
                                      #default="{ errors }"
                                      name="description"
                                      vid="description"
                                      rules="required"
                                    >
                                    <div :class="{ fullscreen: isFullscreen }">
                                      <quill-editor
                                        v-model="commentDescription"
                                        :options="editorOption"
                                        :style="{
                                          width: '98% !important',
                                        }"
                                        class="custom-quill-editor"
                                      >
                                        <div id="toolbar" slot="toolbar">
                                          <!-- Add a bold button -->
                                          <span class="ql-formats">
                                            <button class="ql-bold">
                                              Bold
                                            </button>
                                            <button class="ql-italic">
                                              Italic
                                            </button>
                                            <button class="ql-underline">
                                              Underline
                                            </button>
                                            <button class="ql-strike">
                                              Strike
                                            </button>
                                            <button
                                              class="ql-blockquote"
                                            ></button>
                                            <button
                                              class="ql-list"
                                              value="ordered"
                                            ></button>
                                            <button
                                              class="ql-list"
                                              value="bullet"
                                            ></button>
                                            <button
                                              class="ql-script"
                                              value="sub"
                                            ></button>
                                            <button
                                              class="ql-script"
                                              value="super"
                                            ></button>
                                            <button
                                              class="ql-indent"
                                              value="-1"
                                            ></button>
                                            <button
                                              class="ql-indent"
                                              value="+1"
                                            ></button>
                                            <button
                                              class="ql-direction"
                                              value="rtl"
                                            ></button>
                                            <button
                                              class="ql-align"
                                              value=""
                                            ></button>
                                            <button
                                              class="ql-align"
                                              value="center"
                                            ></button>
                                            <button
                                              class="ql-align"
                                              value="right"
                                            ></button>
                                            <button
                                              class="ql-align"
                                              value="justify"
                                            ></button>
                                            <select class="ql-color"></select>
                                            <select
                                              class="ql-background"
                                            ></select>
                                            <select class="ql-size">
                                              <option value="small" />

                                              <option selected />
                                              <option value="large" />
                                              <option value="huge" />
                                            </select>

                                            <select class="ql-font"></select>
                                            <select class="ql-header">
                                              <option value="1">
                                                Heading 1
                                              </option>
                                              <option value="2">
                                                Heading 2
                                              </option>
                                              <option value="3">
                                                Heading 3
                                              </option>
                                              <option value="4">
                                                Heading 4
                                              </option>
                                              <option value="5">
                                                Heading 5
                                              </option>
                                              <option value="6">
                                                Heading 6
                                              </option>
                                              <option selected>Normal</option>
                                            </select>

                                            <button class="ql-link"></button>
                                            <!-- Fullscreen Button -->
                                            <button type="button" :title="isFullscreen ? 'Exit Fullscreen' : 'Fullscreen'" class="fullscreen-btn" @click="toggleFullscreen">
                                              🔳
                                            </button>
                                          </span>
                                        </div>
                                      </quill-editor>
                                    </div>
                                      <small class="text-danger">{{
                                        errors[0]
                                      }}</small>
                                    </ValidationProvider>
                                  </b-form-group>
                                  <template v-if="isLoading">
                                    <b-button
                                      size="sm"
                                      variant="primary"
                                      disabled
                                    >
                                      <b-spinner small />
                                      Loading...
                                    </b-button>
                                  </template>
                                  <template v-else>
                                    <b-button
                                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                      size="sm"
                                      class="mr-1"
                                      variant="primary"
                                      type="submit"
                                    >
                                      Post Comment
                                    </b-button>
                                    <b-button
                                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                      size="sm"
                                      variant="primary"
                                      v-on:click="hiddenCommentModal"
                                    >
                                      Cancel
                                    </b-button>
                                  </template>
                                </b-form>
                              </validation-observer>
                            </div>
                          </template>
                          <div
                            v-for="(comment, index) in commentList"
                            :key="index"
                            class="d-flex align-items-start mx-2 my-1"
                          >
                            <b-avatar
                              :src="comment?.createdBy?.data?.avatar"
                              size="34"
                              class="mt-25 mr-75"
                            />
                            <div class="profile-user-info w-100">
                              <div
                                class="d-flex align-items-center justify-content-between"
                              >
                                <h6 class="mb-0">
                                  {{ comment?.createdBy?.data?.name }}
                                </h6>
                                <small class="text-muted">{{
                                  formatDateTime(comment?.created_at)
                                }}</small>
                              </div>
                              <div>
                                <template
                                  v-if="
                                    isShowEditCommentModal == true &&
                                    editCommentModalIndex == index
                                  "
                                >
                                  <div class="mt-1">
                                    <validation-observer
                                      ref="editCommentFormValidation"
                                    >
                                      <b-form
                                        v-on:submit.prevent="editCommentForm"
                                      >
                                        <b-form-group>
                                          <ValidationProvider
                                            #default="{ errors }"
                                            name="description"
                                            vid="description"
                                            rules="required"
                                          >
                                          <div :class="{ fullscreen: isFullscreen }">
                                            <quill-editor
                                              v-model="commentDescription"
                                              :options="editorOption"
                                              :style="{
                                                width: '98% !important',
                                              }"
                                              class="custom-quill-editor"
                                            >
                                              <div id="toolbar" slot="toolbar">
                                                <!-- Add a bold button -->
                                                <span class="ql-formats">
                                                  <button class="ql-bold">
                                                    Bold
                                                  </button>
                                                  <button class="ql-italic">
                                                    Italic
                                                  </button>
                                                  <button class="ql-underline">
                                                    Underline
                                                  </button>
                                                  <button class="ql-strike">
                                                    Strike
                                                  </button>
                                                  <button
                                                    class="ql-blockquote"
                                                  ></button>
                                                  <button
                                                    class="ql-list"
                                                    value="ordered"
                                                  ></button>
                                                  <button
                                                    class="ql-list"
                                                    value="bullet"
                                                  ></button>
                                                  <button
                                                    class="ql-script"
                                                    value="sub"
                                                  ></button>
                                                  <button
                                                    class="ql-script"
                                                    value="super"
                                                  ></button>
                                                  <button
                                                    class="ql-indent"
                                                    value="-1"
                                                  ></button>
                                                  <button
                                                    class="ql-indent"
                                                    value="+1"
                                                  ></button>
                                                  <button
                                                    class="ql-direction"
                                                    value="rtl"
                                                  ></button>
                                                  <button
                                                    class="ql-align"
                                                    value=""
                                                  ></button>
                                                  <button
                                                    class="ql-align"
                                                    value="center"
                                                  ></button>
                                                  <button
                                                    class="ql-align"
                                                    value="right"
                                                  ></button>
                                                  <button
                                                    class="ql-align"
                                                    value="justify"
                                                  ></button>
                                                  <select class="ql-color"></select>
                                                  <select
                                                    class="ql-background"
                                                  ></select>
                                                  <select class="ql-size">
                                                    <option value="small" />

                                                    <option selected />
                                                    <option value="large" />
                                                    <option value="huge" />
                                                  </select>

                                                  <select class="ql-font"></select>
                                                  <select class="ql-header">
                                                    <option value="1">
                                                      Heading 1
                                                    </option>
                                                    <option value="2">
                                                      Heading 2
                                                    </option>
                                                    <option value="3">
                                                      Heading 3
                                                    </option>
                                                    <option value="4">
                                                      Heading 4
                                                    </option>
                                                    <option value="5">
                                                      Heading 5
                                                    </option>
                                                    <option value="6">
                                                      Heading 6
                                                    </option>
                                                    <option selected>Normal</option>
                                                  </select>

                                                  <button class="ql-link"></button>
                                                  <!-- Fullscreen Button -->
                                                  <button type="button" :title="isFullscreen ? 'Exit Fullscreen' : 'Fullscreen'" class="fullscreen-btn" @click="toggleFullscreen">
                                                    🔳
                                                  </button>
                                                </span>
                                              </div>
                                            </quill-editor>
                                          </div>

                                            <small class="text-danger">{{
                                              errors[0]
                                            }}</small>
                                          </ValidationProvider>
                                        </b-form-group>
                                        <template v-if="isLoading">
                                          <b-button
                                            size="sm"
                                            variant="primary"
                                            disabled
                                          >
                                            <b-spinner small />
                                            Loading...
                                          </b-button>
                                        </template>
                                        <template v-else>
                                          <b-button
                                            v-ripple.400="
                                              'rgba(255, 255, 255, 0.15)'
                                            "
                                            size="sm"
                                            class="mr-1"
                                            variant="primary"
                                            type="submit"
                                          >
                                            Submit
                                          </b-button>
                                          <b-button
                                            v-ripple.400="
                                              'rgba(255, 255, 255, 0.15)'
                                            "
                                            size="sm"
                                            variant="primary"
                                            v-on:click="hiddenEditCommentModal"
                                          >
                                            Cancel
                                          </b-button>
                                        </template>
                                      </b-form>
                                    </validation-observer>
                                  </div>
                                </template>
                                <template v-else>
                                  <small v-html="comment?.description"> </small>
                                  <small
                                    ><span class="mr-1"
                                      ><b-link
                                        v-if="
                                          authUser?.id ==
                                          comment?.createdBy?.data?.id
                                        "
                                        v-on:click="
                                          onShowEditComment(index, comment)
                                        "
                                        >Edit</b-link
                                      ></span
                                    ><span class="mr-1"
                                      ><b-link
                                        v-if="
                                          authUser?.id ==
                                          comment?.createdBy?.data?.id
                                        "
                                        v-on:click="
                                          onCommentDelete(comment?.id)
                                        "
                                        >Delete</b-link
                                      ></span
                                    ></small
                                  >
                                </template>
                              </div>
                            </div>
                          </div>
                          <!--/ comments -->
                        </b-col>
                      </b-row>
                    </b-card-text>
                  </div>
                </b-tab>
              </b-tabs>
            </b-card>
          </b-col>
        </b-col>
        <b-col cols="12" md="4">
          <b-col cols="12">
            <b-card>
              <b-row>
                <b-col cols="12">
                  <b-card>
                    <b-row>
                      <b-col md="12" lg="12" xs="12" class="mt-2">
                        <h5 class="text-capitalize">Assigner</h5>
                        <div>
                          <template v-if="task?.assignee?.data?.name">
                            <userCard :user="task?.assignee?.data" />
                          </template>
                          <b-card-text v-else>
                            <b-badge variant="light-danger">
                              Not Assigned
                            </b-badge>
                          </b-card-text>
                        </div>
                      </b-col>

                      <b-col md="12" lg="12" xs="12" class="mt-2">
                        <h5 class="text-capitalize">Observer</h5>
                        <div>
                          <b-card-text v-if="task?.observer?.data?.name">
                            <userCard :user="task?.observer?.data" />
                          </b-card-text>
                          <b-card-text v-else>
                            <b-badge variant="light-danger">
                              Not Assigned
                            </b-badge>
                          </b-card-text>
                        </div>
                      </b-col>

                      <b-col md="12" lg="6" xs="12" class="mt-2">
                        <h5 class="text-capitalize">Assign User</h5>
                        <div>
                          <span
                            v-for="(member, index) in task?.team?.data"
                            :key="index"
                          >
                            <template v-if="index <= 2">
                              <b-avatar
                                :src="
                                  member?.avatar === ''
                                    ? '/avatar.svg'
                                    : member?.avatar
                                "
                                size="26"
                            /></template>
                          </span>
                          <span v-if="task?.team?.data.length > 3">
                            + {{ task?.team?.data.length - 3 }} more
                          </span>
                          <b-button
                            variant="outline-primary"
                            class="btn-icon rounded-circle btn-sm ml-1"
                            v-on:click="showAddMemberModal(task)"
                            :disabled="
                              $permissionAbility(
                                MILESTONE_BOARD_TASK_EDIT,
                                permissions
                              )
                                ? false
                                : true
                            "
                          >
                            <feather-icon icon="UserPlusIcon" />
                          </b-button>
                        </div>
                      </b-col>

                      <b-col md="12" lg="6" xs="12">
                        <div class="mt-2">
                          <h5 class="text-capitalize">Labels</h5>
                          <template v-if="task?.labels.data.length > 0">
                            <b-card-text>
                              <span
                                v-for="label in task?.labels.data"
                                :key="label.id"
                              >
                                <b-badge
                                  class="label-margin"
                                  variant="light-primary"
                                >
                                  {{ label.name }} </b-badge
                                >&nbsp;&nbsp;&nbsp;
                              </span>
                            </b-card-text>
                          </template>

                          <template v-else>
                            <b-card-text>
                              <b-badge variant="light-danger"> N/A </b-badge>
                            </b-card-text>
                          </template>
                        </div>
                      </b-col>

                      <b-col md="6" lg="6" xs="12" class="mt-2">
                        <h5 class="text-capitalize">Phase</h5>

                        <template v-if="task?.phase?.data?.title">
                          <b-dropdown
                            no-caret
                            variant="outline-primary"
                            :text="task?.phase?.data?.title"
                            style="padding: 0"
                          >
                            <b-dropdown-item
                              v-for="phase in taskPhaseOptions"
                              :key="phase?.id"
                              v-on:click="updatePhase(phase)"
                            >
                              {{ phase?.title }}
                            </b-dropdown-item>
                            <b-dropdown-divider />
                            <b-dropdown-item v-on:click="onShowPhase">
                              <feather-icon icon="PlusCircleIcon" /> Add More
                            </b-dropdown-item>
                          </b-dropdown>
                        </template>
                      </b-col>
                      <b-col md="6" lg="6" xs="12">
                        <div class="mt-2">
                          <h5 class="text-capitalize">Priority</h5>
                          <template v-if="task?.priority === 'high'">
                            <b-card-text>
                              <b-badge variant="light-danger"> High </b-badge>
                            </b-card-text>
                          </template>
                          <template v-else-if="task?.priority === 'low'">
                            <b-card-text>
                              <b-badge variant="light-success"> Low </b-badge>
                            </b-card-text>
                          </template>
                          <template v-else-if="task?.priority === 'medium'">
                            <b-card-text>
                              <b-badge variant="light-warning">
                                Medium
                              </b-badge>
                            </b-card-text>
                          </template>
                          <template v-else>
                            <b-card-text>
                              <b-badge variant="light-primary">
                                Normal
                              </b-badge>
                            </b-card-text>
                          </template>
                        </div>
                      </b-col>

                      <b-col md="6" lg="6" xs="12">
                        <div class="mt-2">
                          <h5 class="text-capitalize">Status</h5>
                          <template v-if="task?.is_completed">
                            <b-card-text>
                              <b-badge variant="light-success">
                                Completed
                              </b-badge>
                            </b-card-text>
                          </template>
                          <template v-else>
                            <b-card-text>
                              <b-badge variant="light-danger">
                                Not Completed
                              </b-badge>
                            </b-card-text>
                          </template>
                        </div>
                      </b-col>

                      <b-col md="6" lg="6" xs="12">
                        <div class="mt-2">
                          <h5 class="text-capitalize">Estimation Point</h5>
                          <template v-if="task?.point">
                            <b-card-text>
                              <b-badge variant="light-primary">
                                {{ task?.point }}
                              </b-badge>
                            </b-card-text>
                          </template>
                          <template v-else>
                            <b-card-text>
                              <b-badge variant="light-danger"> N/A </b-badge>
                            </b-card-text>
                          </template>
                        </div>
                      </b-col>

                      <b-col md="12" lg="12" xs="12">
                        <div class="mt-2">
                          <h5 class="text-capitalize">Deadline</h5>
                          <template v-if="task?.deadline">
                            <b-card-text>
                              {{ formatDate(task?.deadline) }}
                            </b-card-text>
                          </template>
                          <template v-else>
                            <b-card-text>
                              <b-badge variant="light-danger"> N/A </b-badge>
                            </b-card-text>
                          </template>
                        </div>
                      </b-col>

                      <b-col md="6" lg="6" xs="12">
                        <div class="mt-2">
                          <h5 class="text-capitalize">Actual Start Date</h5>
                          <template v-if="task?.actual_start_date">
                            <b-card-text>
                              {{ formatDate(task?.actual_start_date) }}
                            </b-card-text>
                          </template>
                          <template v-else>
                            <b-card-text>
                              <b-badge variant="light-danger"> N/A </b-badge>
                            </b-card-text>
                          </template>
                        </div>
                      </b-col>

                      <b-col md="6" lg="6" xs="12">
                        <div class="mt-2">
                          <h5 class="text-capitalize">Actual End Date</h5>
                          <template v-if="task?.actual_end_date">
                            <b-card-text>
                              {{ formatDate(task?.actual_end_date) }}
                            </b-card-text>
                          </template>
                          <template v-else>
                            <b-card-text>
                              <b-badge variant="light-danger"> N/A </b-badge>
                            </b-card-text>
                          </template>
                        </div>
                      </b-col>

                      <b-col cols="6" v-if="task?.wordcount">
                        <div class="mt-2">
                          <h5 class="text-capitalize">Word Count</h5>
                          <template>
                            <b-card-text>
                              <b-badge variant="light-primary">
                                {{ task?.wordcount }}
                              </b-badge>
                            </b-card-text>
                          </template>
                        </div>
                      </b-col>
                      <b-col cols="6" v-if="task?.contentlink">
                        <div class="mt-2">
                          <h5 class="text-capitalize">Content Link</h5>
                          <template v-if="task?.contentlink">
                            <b-card-text>
                              <b-badge variant="primary" class="badge-glow">
                                <a :href="task.contentlink" target="_blank"
                                  >View Content</a
                                >
                              </b-badge>
                            </b-card-text>
                          </template>
                        </div>
                      </b-col>
                    </b-row>
                  </b-card>
                </b-col>
              </b-row>
            </b-card>
          </b-col>

          <b-col cols="12">
            <b-card-code>
              <b-tabs>
                <b-tab title="Activity Log">
                  <div class="log-scrollable">
                    <b-card>
                      <app-timeline>
                        <app-timeline-item
                          v-for="(log, index) in taskActivityLog"
                          :key="index"
                          variant="primary"
                        >
                          <div
                            class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0"
                          >
                            <h6 v-html="formatLogTitle(log)"></h6>
                            <small class="text-muted">{{
                              formatDateTime(log?.created_at)
                            }}</small>
                          </div>
                          <p v-html="formatLogDescription(log)"></p>
                        </app-timeline-item>
                      </app-timeline>
                    </b-card>
                  </div>
                </b-tab>
                <b-tab
                  title="Phase Duration Log"
                  v-on:click="loadTimeDurationLog"
                >
                  <div class="log-scrollable">
                    <b-card>
                      <template v-if="phaseChangeLog.length > 0">
                        <app-timeline>
                          <!-- 12 INVOICES HAVE BEEN PAID -->
                          <app-timeline-item
                            v-for="(log, index) in phaseChangeLog"
                            :key="index"
                            :variant="setLogVariant(log)"
                          >
                            <div
                              class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0"
                            >
                              <h6 v-html="formatPhaseLogTitle(log)"></h6>
                              <small class="text-muted">{{
                                formatDateTime(log?.created_at)
                              }}</small>
                            </div>
                            <p
                              v-html="
                                formatPhaseLogDescription(
                                  log?.created_at,
                                  nextPhaseChangeStartTime[index]
                                )
                              "
                            ></p>
                          </app-timeline-item>
                        </app-timeline>
                      </template>
                    </b-card>
                  </div>
                </b-tab>
              </b-tabs>
            </b-card-code>
          </b-col>
        </b-col>
      </b-row>

      <div>
        <b-modal
          id="modal-task-board-phase-task"
          centered
          title="Edit Task Information"
          hide-footer
          @hidden="hiddenTaskModal"
          size="lg"
          no-close-on-backdrop
        >
          <validation-observer ref="taskEdit">
            <b-form v-on:submit.prevent="taskEditForm">
              <b-row>
                <!-- <b-col md="6" lg="6" xs="12">
                  <b-form-group
                    label="Title "
                    label-for="title"
                    class="required-label"
                  >
                    <ValidationProvider
                      name="title"
                      v-slot="{ errors }"
                      vid="title"
                      rules="required"
                    >
                      <b-form-input
                        id="title"
                        type="text"
                        class="custom-font"
                        v-model="title"
                        :state="errors.length > 0 ? false : null"
                        placeholder="Enter task title"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </ValidationProvider>
                  </b-form-group>
                </b-col> -->

                <b-col md="6" lg="6" xs="12">
                  <div class="d-flex justify-content-between">
                    <b-form-group
                      label="Title"
                      label-for="title"
                      class="required-label"
                    >
                    </b-form-group>

                    <!-- Loader inside input field -->
                    <div class="input-loader" v-if="taskSuggestionLoading">
                      <b-spinner small />
                    </div>

                    <!-- Small round button below the input field -->
                    <div
                      v-if="isAiEnabled"
                      class="text-right suggestion-button-position"
                    >
                      <b-button
                        variant="outline-primary"
                        class="rounded-circle p-1 hover-effect button-icon"
                        size="sm"
                        v-b-tooltip.hover.v-primary
                        title="Generate With AI"
                        @click="getSuggestion(title, 'title')"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="icon icon-tabler icons-tabler-outline icon-tabler-sparkles"
                        >
                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                          <path
                            d="M16 18a2 2 0 0 1 2 2a2 2 0 0 1 2 -2a2 2 0 0 1 -2 -2a2 2 0 0 1 -2 2zm0 -12a2 2 0 0 1 2 2a2 2 0 0 1 2 -2a2 2 0 0 1 -2 -2a2 2 0 0 1 -2 2zm-7 12a6 6 0 0 1 6 -6a6 6 0 0 1 -6 -6a6 6 0 0 1 -6 6a6 6 0 0 1 6 6z"
                          />
                        </svg>
                      </b-button>
                    </div>
                  </div>

                  <ValidationProvider
                    name="title"
                    v-slot="{ errors }"
                    vid="title"
                    rules="required"
                  >
                    <b-input-group

                    >
                      <!-- Input field -->
                      <b-form-input
                        id="title"
                        type="text"
                        class="custom-font"
                        v-model="title"
                        :state="errors.length > 0 ? false : null"
                        placeholder="Enter task title"
                      />
                    </b-input-group>

                    <small class="text-danger">{{ errors[0] }}</small>
                  </ValidationProvider>
                </b-col>

                <b-col md="6" lg="6" xs="12">
                  <b-form-group label="Type " label-for="type">
                    <ValidationProvider
                      name="type"
                      v-slot="{ errors }"
                      vid="type"
                    >
                      <v-select
                        id="type"
                        v-model="type"
                        :options="taskSubtaskTypeOptionConstant"
                        :reduce="(option) => option.value"
                        placeholder="Select task type"
                        label="name"
                        class="custom-font"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </ValidationProvider>
                  </b-form-group>
                </b-col>

                <b-col md="6" lg="6" xs="12">
                  <b-form-group label="Priority " label-for="priority">
                    <ValidationProvider
                      name="priority"
                      v-slot="{ errors }"
                      vid="priority"
                    >
                      <v-select
                        id="priority"
                        v-model="selectPriorityType"
                        :options="priorityOptionConstants"
                        :reduce="(option) => option.value"
                        placeholder="Select task priority"
                        label="name"
                        class="custom-font"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </ValidationProvider>
                  </b-form-group>
                </b-col>

                <b-col md="6" lg="6" xs="12">
                  <b-form-group label="Label" label-for="labels">
                    <ValidationProvider
                      name="labels"
                      v-slot="{ errors }"
                      vid="labels"
                    >
                      <v-select
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        id="labels"
                        class="custom-font"
                        placeholder="Add Task Label"
                        v-model="selectLabels"
                        label="name"
                        multiple
                        taggable
                        push-tags
                      >
                      </v-select>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </ValidationProvider>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6" lg="6" xs="12">
                  <b-form-group label="Estimation Point" label-for="point">
                    <validation-provider
                      #default="{ errors }"
                      name="point"
                      vid="point"
                      rules="min_value:0|max_value:9999"
                    >
                      <b-form-input
                        id="point"
                        type="text"
                        v-model="point"
                        :state="errors.length > 0 ? false : null"
                        placeholder="Enter Estimation Point"
                        class="custom-font"
                      />

                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <b-col md="6" lg="6" xs="12">
                  <b-form-group label="Observer" label-for="observer">
                    <ValidationProvider
                      name="observer"
                      v-slot="{ errors }"
                      vid="observer"
                    >
                      <v-select
                        id="observer"
                        v-model="selectObserver"
                        :options="milestoneBoardTeamMemberIdOptions"
                        :reduce="(option) => option.id"
                        placeholder="Select Observer"
                        label="name"
                        class="custom-font"
                      >
                        <template #option="data">
                          <UserSelect :user="data" />
                        </template>
                      </v-select>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </ValidationProvider>
                  </b-form-group>
                </b-col>

                <b-col md="6" lg="6" xs="12">
                  <b-form-group label="Assigner" label-for="assigner">
                    <ValidationProvider
                      name="assigner"
                      v-slot="{ errors }"
                      vid="assigner"
                    >
                      <v-select
                        id="assigner"
                        v-model="selectAssignee"
                        :options="allMemberIdOptions"
                        :reduce="(option) => option.id"
                        placeholder="Select assigner"
                        label="name"
                        class="custom-font"
                      >
                        <template #option="data">
                          <UserSelect :user="data" />
                        </template>
                      </v-select>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </ValidationProvider>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <div class="d-flex justify-content-between">
                    <b-form-group label="Description" label-for="description">
                    </b-form-group>

                    <div class="input-loader-des" v-if="desSuggestionLoading">
                      <b-spinner small />
                    </div>

                    <div
                      v-if="isAiEnabled"
                      class="text-right suggestion-button-position"
                    >
                      <b-button
                        variant="outline-primary"
                        class="rounded-circle p-1 hover-effect button-icon"
                        size="sm"
                        v-b-tooltip.hover.v-primary
                        title="Generate With AI"
                        @click="getSuggestion(description, 'description')"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="icon icon-tabler icons-tabler-outline icon-tabler-sparkles"
                        >
                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                          <path
                            d="M16 18a2 2 0 0 1 2 2a2 2 0 0 1 2 -2a2 2 0 0 1 -2 -2a2 2 0 0 1 -2 2zm0 -12a2 2 0 0 1 2 2a2 2 0 0 1 2 -2a2 2 0 0 1 -2 -2a2 2 0 0 1 -2 2zm-7 12a6 6 0 0 1 6 -6a6 6 0 0 1 -6 -6a6 6 0 0 1 -6 6a6 6 0 0 1 6 6z"
                          />
                        </svg>
                      </b-button>
                    </div>
                  </div>
                  <ValidationProvider
                    #default="{ errors }"
                    name="description"
                    vid="description"
                  >
                    <template v-if="taskEditClicked">
                      <div :class="{ fullscreen: isFullscreen }">
                        <quill-editor
                          v-model="description"
                          :options="editorOption"
                          :style="{
                            height: '13rem !important',
                            paddingBottom: '5rem !important',
                          }"
                          class="custom-quill-editor"
                        >
                          <div id="toolbar" slot="toolbar">
                            <!-- Add a bold button -->
                            <span class="ql-formats">
                              <button class="ql-bold">Bold</button>
                              <button class="ql-italic">Italic</button>
                              <button class="ql-underline">Underline</button>
                              <button class="ql-strike">Strike</button>
                              <button class="ql-blockquote"></button>
                              <button class="ql-list" value="ordered"></button>
                              <button class="ql-list" value="bullet"></button>
                              <button class="ql-script" value="sub"></button>
                              <button class="ql-script" value="super"></button>
                              <button class="ql-indent" value="-1"></button>
                              <button class="ql-indent" value="+1"></button>
                              <button class="ql-direction" value="rtl"></button>
                              <button class="ql-align" value=""></button>
                              <button class="ql-align" value="center"></button>
                              <button class="ql-align" value="right"></button>
                              <button class="ql-align" value="justify"></button>
                              <select class="ql-color"></select>
                              <select class="ql-background"></select>
                              <select class="ql-size">
                                <option value="small" />

                                <option selected />
                                <option value="large" />
                                <option value="huge" />
                              </select>

                              <select class="ql-font"></select>
                              <select class="ql-header">
                                <option value="1">Heading 1</option>
                                <option value="2">Heading 2</option>
                                <option value="3">Heading 3</option>
                                <option value="4">Heading 4</option>
                                <option value="5">Heading 5</option>
                                <option value="6">Heading 6</option>
                                <option selected>Normal</option>
                              </select>

                              <button class="ql-link"></button>
                              <button type="button" :title="isFullscreen ? 'Exit Fullscreen' : 'Fullscreen'" class="fullscreen-btn" @click="toggleFullscreen">
                                🔳
                              </button>
                            </span>
                          </div>
                        </quill-editor>
                      </div>
                    </template>

                    <small class="text-danger">{{ errors[0] }}</small>
                  </ValidationProvider>
                </b-col>
              </b-row>
              <template v-if="previousFiles.length > 0">
                <b-row class="mb-2">
                  <b-col>
                    <div class="scrollable-file-container">
                      <div class="uploaded-files mb-2 scrollable-file-content">
                        <div
                          v-for="(item, index) in previousFiles"
                          :key="index"
                          class="file-preview"
                        >
                          <b-row class="mr-1">
                            <b-col md="8" lg="8" xs="12">
                              <div v-b-tooltip.hover.bottom="item.file_name">
                                <template v-if="isPreviousFileImage(item)">
                                  <img
                                    :src="item?.original_url"
                                    alt="Preview"
                                    width="100"
                                    height="100"
                                  />
                                </template>

                                <template v-else>
                                  <svg
                                    width="100px"
                                    height="100px"
                                    viewBox="0 0 24 24"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="#000000"
                                  >
                                    <g
                                      id="SVGRepo_bgCarrier"
                                      stroke-width="0"
                                    ></g>
                                    <g
                                      id="SVGRepo_tracerCarrier"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    ></g>
                                    <g id="SVGRepo_iconCarrier">
                                      <title></title>
                                      <g id="Complete">
                                        <g id="F-File">
                                          <g id="Text">
                                            <g>
                                              <path
                                                d="M18,22H6a2,2,0,0,1-2-2V4A2,2,0,0,1,6,2h7.1a2,2,0,0,1,1.5.6l4.9,5.2A2,2,0,0,1,20,9.2V20A2,2,0,0,1,18,22Z"
                                                fill="none"
                                                id="File"
                                                stroke="#000000"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                stroke-width="2"
                                              ></path>
                                              <line
                                                fill="none"
                                                stroke="#000000"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                stroke-width="2"
                                                x1="7.9"
                                                x2="16.1"
                                                y1="17.5"
                                                y2="17.5"
                                              ></line>
                                              <line
                                                fill="none"
                                                stroke="#000000"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                stroke-width="2"
                                                x1="7.9"
                                                x2="16.1"
                                                y1="13.5"
                                                y2="13.5"
                                              ></line>
                                              <line
                                                fill="none"
                                                stroke="#000000"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                stroke-width="2"
                                                x1="8"
                                                x2="13"
                                                y1="9.5"
                                                y2="9.5"
                                              ></line>
                                            </g>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </svg>
                                </template>
                              </div>
                            </b-col>
                            <b-col md="3" lg="3" xs="12">
                              <b-button
                                class="flex-shrink-0 btn-sm"
                                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                variant="outline-danger"
                                @click="removePreviousFile(index)"
                              >
                                <feather-icon icon="XIcon" />
                              </b-button>
                              <br />
                              <br />
                              <b-button
                                class="flex-shrink-0 btn-sm"
                                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                variant="outline-primary"
                                @click="onShowImage(item)"
                              >
                                <feather-icon icon="EyeIcon" />
                              </b-button>
                            </b-col>
                          </b-row>
                        </div>
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </template>

              <b-row>
                <b-col>
                  <div class="file-input">
                    <label for="file-upload" class="attach-icon">
                      Attach File
                      <feather-icon
                        icon="PaperclipIcon"
                        class="mr-50"
                        style="color: #7367f0"
                      />
                    </label>
                    <input
                      hidden
                      id="file-upload"
                      type="file"
                      multiple
                      @change="handleFileUpload"
                    />
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <div class="scrollable-file-container">
                    <div class="uploaded-files mb-2 scrollable-file-content">
                      <div
                        v-for="(file, index) in uploadedFiles"
                        :key="index"
                        class="file-preview"
                      >
                        <b-row class="mr-1">
                          <b-col md="8" lg="8" xs="12">
                            <div v-b-tooltip.hover.bottom="file.name">
                              <template v-if="isImage(file)">
                                <img
                                  :src="file.preview"
                                  alt="Preview"
                                  width="100"
                                  height="100"
                                />
                              </template>
                              <template v-else>
                                <svg
                                  width="100px"
                                  height="100px"
                                  viewBox="0 0 24 24"
                                  xmlns="http://www.w3.org/2000/svg"
                                  fill="#000000"
                                >
                                  <g
                                    id="SVGRepo_bgCarrier"
                                    stroke-width="0"
                                  ></g>
                                  <g
                                    id="SVGRepo_tracerCarrier"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  ></g>
                                  <g id="SVGRepo_iconCarrier">
                                    <title></title>
                                    <g id="Complete">
                                      <g id="F-File">
                                        <g id="Text">
                                          <g>
                                            <path
                                              d="M18,22H6a2,2,0,0,1-2-2V4A2,2,0,0,1,6,2h7.1a2,2,0,0,1,1.5.6l4.9,5.2A2,2,0,0,1,20,9.2V20A2,2,0,0,1,18,22Z"
                                              fill="none"
                                              id="File"
                                              stroke="#000000"
                                              stroke-linecap="round"
                                              stroke-linejoin="round"
                                              stroke-width="2"
                                            ></path>
                                            <line
                                              fill="none"
                                              stroke="#000000"
                                              stroke-linecap="round"
                                              stroke-linejoin="round"
                                              stroke-width="2"
                                              x1="7.9"
                                              x2="16.1"
                                              y1="17.5"
                                              y2="17.5"
                                            ></line>
                                            <line
                                              fill="none"
                                              stroke="#000000"
                                              stroke-linecap="round"
                                              stroke-linejoin="round"
                                              stroke-width="2"
                                              x1="7.9"
                                              x2="16.1"
                                              y1="13.5"
                                              y2="13.5"
                                            ></line>
                                            <line
                                              fill="none"
                                              stroke="#000000"
                                              stroke-linecap="round"
                                              stroke-linejoin="round"
                                              stroke-width="2"
                                              x1="8"
                                              x2="13"
                                              y1="9.5"
                                              y2="9.5"
                                            ></line>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </g>
                                </svg>
                              </template>
                            </div>
                          </b-col>
                          <b-col md="3" lg="3" xs="12">
                            <b-button
                              class="flex-shrink-0 btn-sm"
                              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                              variant="outline-danger"
                              @click="removeFile(index)"
                            >
                              <feather-icon icon="XIcon" />
                            </b-button>
                          </b-col>
                        </b-row>
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12" lg="12" xs="12">
                  <b-form-group label="Deadline" label-for="deadline">
                    <ValidationProvider
                      name="deadline"
                      v-slot="{ errors }"
                      vid="deadline"
                    >
                      <b-form-datepicker
                        id="deadline"
                        v-model="deadline"
                        class="form-control custom-font"
                        :state="errors.length > 0 ? false : null"
                        locale="en-US"
                        today-button
                        close-button
                        reset-button
                        placeholder="Deadline"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </ValidationProvider>
                  </b-form-group>
                </b-col>

                <b-col md="6" lg="6" xs="12">
                  <b-form-group
                    label="Actual Start Date"
                    label-for="actual_start_date"
                  >
                    <ValidationProvider
                      name="actual_start_date"
                      v-slot="{ errors }"
                      vid="actual_start_date"
                    >
                      <b-form-datepicker
                        id="actual_start_date"
                        v-model="actualStartDate"
                        class="form-control custom-font"
                        :state="errors.length > 0 ? false : null"
                        locale="en-US"
                        today-button
                        close-button
                        reset-button
                        placeholder="Actual Start Date "
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </ValidationProvider>
                  </b-form-group>
                </b-col>

                <b-col md="6" lg="6" xs="12">
                  <b-form-group
                    label="Actual End Date"
                    label-for="actual_end_date"
                  >
                    <ValidationProvider
                      name="actual_end_date"
                      v-slot="{ errors }"
                      vid="actual_end_date"
                    >
                      <b-form-datepicker
                        id="actual_end_date"
                        v-model="actualEndDate"
                        class="form-control custom-font"
                        :state="errors.length > 0 ? false : null"
                        locale="en-US"
                        today-button
                        close-button
                        reset-button
                        placeholder="Actual End Date "
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </ValidationProvider>
                  </b-form-group>
                </b-col>

                <b-col md="6" lg="6" xs="12">
                  <b-form-group label="Word Count" label-for="wordcount">
                    <ValidationProvider
                      name="wordcount"
                      v-slot="{ errors }"
                      vid="wordcount"
                    >
                      <b-form-input
                        id="wordcount"
                        type="text"
                        class="custom-font"
                        v-model="wordcount"
                        :state="errors.length > 0 ? false : null"
                        placeholder="Enter task Content Wordcount"
                        :disabled="sub_tasks_sum_wordcount > 0"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </ValidationProvider>
                  </b-form-group>
                  <small
                    v-if="this.sub_tasks_sum_wordcount > 0"
                    class="text-danger"
                    >Task word count not available when sub task has word
                    count</small
                  >
                </b-col>
                <b-col md="6" lg="6" xs="12">
                  <!-- content Link -->
                  <b-form-group label="Content Link" label-for="contentlink">
                    <ValidationProvider
                      v-slot="{ errors }"
                      name="contentlink"
                      vid="contentlink"
                    >
                      <b-form-input
                        id="contentlink"
                        type="text"
                        class="custom-font"
                        v-model="contentlink"
                        :state="errors.length > 0 ? false : null"
                        placeholder="Enter task Content Link"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </ValidationProvider>
                  </b-form-group>
                </b-col>
              </b-row>
              <!-- loading button -->
              <template v-if="isLoading">
                <b-button class="float-right" variant="primary" disabled>
                  <b-spinner small />
                  Loading...
                </b-button>
              </template>

              <!-- submit button -->
              <template v-else>
                <b-button
                  type="submit"
                  class="float-right mt-2"
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                >
                  Submit
                </b-button>
              </template>
            </b-form>
          </validation-observer>
        </b-modal>
      </div>

      <div>
        <b-modal
          id="file-preview-modal"
          centered
          title="File Preview"
          hide-footer
          @hidden="hiddenFilePreviewModal"
          no-close-on-backdrop
        >
          <template>
            <b-img :src="previewFile" fluid-grow alt="Fluid-grow image" />

            <p class="text-center">
              Open in new
              <b-link :href="previewFile" target="_blank">window</b-link>
            </p>
          </template>
        </b-modal>
      </div>

      <div>
        <b-modal
          id="modal-add-member-form"
          centered
          title="Add Member"
          hide-footer
          @hidden="hiddenAddMemberModal"
          no-close-on-backdrop
        >
          <validation-observer ref="addMemberValidation">
            <b-form v-on:submit.prevent="addMemberValidationForm">
              <!-- select member-->
              <b-form-group label="Member" label-for="user_id">
                <ValidationProvider
                  name="user_id"
                  v-slot="{ errors }"
                  vid="user_id"
                >
                  <v-select
                    id="user_id"
                    placeholder="Search by employee name or email"
                    v-model="selectMemberIds"
                    :filterable="false"
                    :options="allMemberIdOptions"
                    :reduce="(item) => item.id"
                    label="name"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    multiple
                  >
                    <template #option="data">
                      <UserSelect :user="data" />
                    </template>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </ValidationProvider>
              </b-form-group>

              <!-- loading button -->
              <template v-if="isLoading">
                <b-button class="float-right" variant="primary" disabled>
                  <b-spinner small />
                  Loading...
                </b-button>
              </template>

              <!-- submit button -->
              <template v-else>
                <b-button
                  type="submit"
                  class="float-right"
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                >
                  Add
                </b-button>
              </template>
            </b-form>
          </validation-observer>
        </b-modal>
      </div>
    </template>
  </section>
</template>
<!--  -->
<script>
import {
  BLink,
  BCard,
  BAvatar,
  BBadge,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BDropdown,
  BDropdownItem,
  BFormFile,
  BButton,
  BForm,
  BModal,
  BCol,
  BRow,
  BCardText,
  BFormTextarea,
  BSpinner,
  BAlert,
  VBTooltip,
  BFormDatepicker,
  BTabs,
  BTab,
  BImg,
  BMedia,
  BAvatarGroup,
  BEmbed,
  BDropdownDivider,
  BButtonGroup,
  BListGroup,
  BListGroupItem,
  BBreadcrumb,
  BBreadcrumbItem,
  BInputGroup,
} from "bootstrap-vue";
import BCardCode from "@core/components/b-card-code";
import { VueGoodTable } from "vue-good-table";
import { quillEditor } from "vue-quill-editor";
import Ripple from "vue-ripple-directive";
import { ValidationProvider, ValidationObserver } from "vee-validate";

import { required, max, size, ext, max_value, min_value } from "@validations";
import flatPickr from "vue-flatpickr-component";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { mapGetters } from "vuex";
import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";
import { formatDate, kFormatter } from "@core/utils/filter";
import draggable from "vuedraggable";
import Prism from "vue-prism-component";
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";

import { priorityOptionConstants } from "@/helpers/constant/priorityOptionConstant";
import { taskSubtaskTypeOptionConstant } from "@/helpers/constant/taskSubtaskTypeOptionConstant";
import {
  MILESTONE_BOARD_SUB_TASK_EDIT,
  MILESTONE_BOARD_SUB_TASK_DELETE,
  MILESTONE_BOARD_SUB_TASK_CREATE,
  MILESTONE_BOARD_TASK_EDIT,
} from "@/helpers/permissionsConstant";
import UserSelect from "@/layouts/components/UserSelect.vue";
import UserCard from "@/layouts/components/UserCard.vue";
import { result } from "lodash";

export default {
  name: "TaskDetailsView",
  components: {
    UserCard,
    UserSelect,
    BLink,
    BForm,
    BButton,
    BCard,
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormFile,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    ValidationProvider,
    ValidationObserver,
    BModal,
    BCol,
    BRow,
    BCardText,
    BSpinner,
    BFormTextarea,
    flatPickr,
    BAlert,
    BFormDatepicker,
    BTabs,
    BTab,
    BImg,
    BMedia,
    AppTimeline,
    AppTimelineItem,
    BAvatarGroup,
    BEmbed,
    BDropdownDivider,
    quillEditor,
    BCardCode,
    BButtonGroup,
    BListGroup,
    BListGroupItem,
    BBreadcrumb,
    BBreadcrumbItem,
    draggable,
    Prism,
    BInputGroup,
  },
  directives: {
    Ripple,
    "b-tooltip": VBTooltip,
  },
  methods: {
    formatDate,
    kFormatter,
  },
  data() {
    return {
      editorOption: {
        modules: {
          toolbar: "#toolbar",
        },
      },
      MILESTONE_BOARD_SUB_TASK_EDIT,
      MILESTONE_BOARD_SUB_TASK_CREATE,
      MILESTONE_BOARD_TASK_EDIT,
      MILESTONE_BOARD_SUB_TASK_DELETE,

      suggestion: "",

      showCopiedMessage: false,

      isTaskDetailsPageLoading: false,

      taskSuggestionLoading: false,
      desSuggestionLoading: false,
      isAiEnabled: false,

      //Phase Duration Log
      timeDurationLog: [],
      phaseChangeLog: [],
      nextPhaseChangeStartTime: [],
      //Members
      isSearchingMember: false,
      searchMember: "",
      selectMemberIds: [],
      searchMemberIdOptions: [],
      memberIdOptions: [],
      //Sub Task
      subTaskId: "",
      subTaskTitle: "",
      isSubTaskFormLoaded: false,
      selectSubTaskSequence: "",
      subTaskSequenceOption: [],
      hasSequential: false,
      nextTask: {},

      //phase update
      taskPhaseId: "",

      // task
      taskId: "",
      isTaskLinkFormLoaded: false,
      title: "",
      description: "",
      summary: "",
      wordcount: "",
      sub_tasks_sum_wordcount: 0,
      contentlink: "",
      type: "",
      selectType: "",
      priorityOptionConstants,
      taskSubtaskTypeOptionConstant,
      point: "",
      actualStartDate: "",
      deadline: "",
      actualEndDate: "",
      selectPhaseId: "",
      taskPhaseOptions: [],
      selectLabels: [],
      labelIdOptions: [],
      searchLabelIdOptions: [],
      selectMemberIds: [],
      selectTeamMemberIds: [],
      memberIdOptions: [],
      milestoneBoardTeamMemberIdOptions: [],
      uploadedFiles: [],
      taskFiles: [],
      previousFiles: [],
      subTaskList: [],
      generalSubTaskList: [],
      sequencetialSubTaskList: [],

      allTaskList: [],

      // task list
      tasksIdOption: [],
      task_id: "",
      isTaskLinkLoading: false,
      taskLinkList: [],

      isSubTaskLoading: false,

      //comment
      commentDescription: "",
      commentList: [],
      commentId: "",

      //activity log
      taskActivityLog: [],

      //toggling text editor
      taskEditClicked: false,
      isShowCommentModal: false,
      isShowEditCommentModal: false,
      editCommentModalIndex: "",

      // file preview
      previewFile: "",
      taskDetailsPreviousFiles: [],

      //add assignee
      allMemberIdOptions: [],
      selectAssignee: "",

      task: {},
      lead: {},

      rows: [],
      searchTerm: "",
      delayTimer: null,
      isLoading: false,
      isFullscreen: false,
    };
  },
  computed: {
    ...mapGetters({
      permissions: "userModule/getPermissions",
      authUser: "userModule/getUser",
    }),
  },

  async created() {
    try {
      this.isTaskDetailsPageLoading = true;
      this.isAiEnabled = process.env.VUE_APP_AI_ENABLED;

      await this.loadItems();

      this.loadActivityLog();
    } catch (error) {
      if (error?.response?.data?.message) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Warning",
            icon: "BellIcon",
            variant: "warning",
            text: error?.response?.data?.message,
          },
        });
      }
    } finally {
      this.isTaskDetailsPageLoading = false;
    }
  },
  methods: {
    async getSuggestion(text, type) {
      if (type === "title") {
        this.taskSuggestionLoading = true;
      } else {
        this.desSuggestionLoading = true;
      }
      try {
        const response = await this.$api.post("/api/generate-content", {
          content: text,
          type: type,
        });

        const resData = response?.data?.result;

        if (typeof resData === "string") {
          const result = resData.replace(/^["'](.*)["']$/, "$1").trim();

          if (type === "title") {
            this.title = result;
          } else {
            this.description = result;
          }
        }

        if (type === "title") {
          this.taskSuggestionLoading = false;
        } else {
          this.desSuggestionLoading = false;
        }
      } catch (error) {
        if (error) {
          if (type === "title") {
            this.taskSuggestionLoading = false;
          } else {
            this.desSuggestionLoading = false;
          }

          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Warning",
              icon: "BellIcon",
              variant: "warning",
              text: error,
            },
          });
        }
      }
    },
    onShowImage(index) {
      if (this.isPreviousFileImage(index)) {
        this.previewFile = index.original_url;
        this.$bvModal.show("file-preview-modal");
      } else {
        window.open(index.original_url, "_blank");
      }
    },

    hiddenFilePreviewModal() {
      this.previewFile = "";
      this.$bvModal.hide("file-preview-modal");
    },

    formatDate(dateString) {
      if (dateString) {
        const date = new Date(dateString);
        const month = date.toLocaleString("default", { month: "short" });
        const day = date.getDate();
        const year = date.getFullYear();
        return `${month} ${day}, ${year}`;
      }
      return "";
    },

    // copy link
    copyUrlToClipboard() {
      const currentPageURL = window.location.href;

      navigator.clipboard
        .writeText(currentPageURL)
        .then(() => {
          this.showCopiedMessage = true;
          setTimeout(() => {
            this.showCopiedMessage = false;
          }, 2000); // Show the message for 2 seconds
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Error",
              icon: "BellIcon",
              variant: "danger",
              text: error,
            },
          });
        });
    },

    /*** File Upload Start ***/
    handleFileUpload(event) {
      const files = event.target.files;
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        if (!this.checkDuplicateFile(file)) {
          this.uploadedFiles.push({
            name: file.name,
            preview: URL.createObjectURL(file),
            type: file.type,
          });

          this.taskFiles.push(file);
        }
      }
    },
    checkDuplicateFile(file) {
      return this.uploadedFiles.some(
        (uploadedFile) => uploadedFile.name === file.name
      );
    },
    isImage(file) {
      return file.type.startsWith("image/");
    },

    removeFile(index) {
      this.uploadedFiles.splice(index, 1);
    },

    //previous file
    isPreviousFileImage(file) {
      return file.mime_type.startsWith("image/");
    },
    removePreviousFile(index) {
      this.previousFiles.splice(index, 1);
    },
    /*** File Upload End***/

    /** Toggling Text Editor For Comment Section*/

    onShowEditComment(index, value) {
      this.editCommentModalIndex = index;
      this.isShowEditCommentModal = true;
      this.isShowCommentModal = false;
      this.taskEditClicked = false;
      this.commentId = value?.id;
      this.commentDescription = value?.description;
    },
    hiddenEditCommentModal() {
      this.isShowEditCommentModal = false;
      this.editCommentModalIndex = "";
      this.resetComment();
    },

    showCommentModal() {
      this.isShowEditCommentModal = false;
      this.isShowCommentModal = true;
      this.taskEditClicked = false;
      this.resetComment();
    },
    hiddenCommentModal() {
      this.taskEditClicked = true;
      this.isShowCommentModal = false;
      this.resetComment();
    },
    showTaskModalToggleTextEditor() {
      this.taskEditClicked = true;
      this.isShowCommentModal = false;
      this.isShowEditCommentModal = false;
    },

    resetToogleVariable() {
      taskEditClicked = false;
      isShowCommentModal = false;
      isShowEditCommentModal = false;
      editCommentModalIndex = "";
    },
    /** Toggling Text Editor For Comment Section End*/

    /** Task Activity Log Section Start */
    formatLogDescription(value) {
      let description = "";
      if (value?.event != "created") {
        if (value?.event == "updated") {
          //showing task update (Phase and Priority) activity log
          if (value?.log_name == "tasks") {
            if (
              value?.properties?.old?.phase_id !=
              value?.properties?.attributes?.phase_id
            ) {
              description = `Phase updated from <span class="font-weight-bolder text-warning">${value?.properties?.old?.phase?.title} </span> to  <span class="font-weight-bolder text-warning">${value?.properties?.attributes?.phase?.title} </span> <br>`;
            }

            if (
              value?.properties?.old?.priority !=
              value?.properties?.attributes?.priority
            ) {
              const oldPriorityName = this.priorityOptionConstants.reduce(
                (acc, option) => {
                  if (option.value === value?.properties?.old?.priority) {
                    return option.name;
                  }
                  return acc;
                },
                ""
              );

              const newPriorityName = this.priorityOptionConstants.reduce(
                (acc, option) => {
                  if (
                    option.value === value?.properties?.attributes?.priority
                  ) {
                    return option.name;
                  }
                  return acc;
                },
                ""
              );

              description =
                description +
                `Priority updated from <span class="font-weight-bolder text-warning">${oldPriorityName} </span> to  <span class="font-weight-bolder text-warning">${newPriorityName} </span>`;
            }
          }

          if (value?.log_name == "comments") {
            description = "[Previous]";
            description = description + value?.properties?.old?.description;

            description = description + "[Updated]";
            description =
              description + value?.properties?.attributes?.description;
          }
        }

        if (value?.event == "deleted") {
          if (value?.log_name == "comments") {
            description = "[Deleted]";
            description = description + value?.properties?.old?.description;
          }
        }

        if (value?.log_name === "default") {
          if (value?.description == "Task Team Assign Activity Logged") {
            let removedMembers = value?.properties?.removed_members;

            if (removedMembers.length > 0) {
              for (let i = 0; i < removedMembers.length - 1; i++) {
                description =
                  description +
                  `<span class="font-weight-bolder text-danger">${removedMembers[i].name} (${removedMembers[i]?.email})</span>, `;
              }

              description =
                description +
                `<span class="font-weight-bolder text-danger">${
                  removedMembers[removedMembers.length - 1].name
                } (${
                  removedMembers[removedMembers.length - 1]?.email
                })</span> were removed from the Task. <br><br>`;
            }

            let addedMembers = value?.properties?.added_members;

            if (addedMembers.length > 0) {
              for (let i = 0; i < addedMembers.length - 1; i++) {
                description =
                  description +
                  `<span class="font-weight-bolder text-warning">${addedMembers[i].name} (${addedMembers[i]?.email})</span>, `;
              }

              description =
                description +
                `<span class="font-weight-bolder text-warning">${
                  addedMembers[addedMembers.length - 1].name
                } (${
                  addedMembers[addedMembers.length - 1]?.email
                })</span> were assigned to the Task.`;
            }
          }
        }
      }

      if (value?.event == "created") {
        if (value?.log_name == "comments") {
          description = description + "[New Comment]";
          description =
            description + value?.properties?.attributes?.description;
        }
      }

      return description;
    },
    eventCreatedBy(value) {
      if (value.causer_type === "App\\Models\\User") {
        // Show name
        const filteredMembers = this.allMemberIdOptions.filter((member) => {
          return member.id === value.causer_id;
        });

        const createdUserNames = filteredMembers
          .map((member) => member.name)
          .join(", ");

        return createdUserNames;
      }

      return false;
    },
    formatLogTitle(value) {
      let logTitle = "";
      let eventCreatedBy = "";

      let getEventCreatedBy = this.eventCreatedBy(value);

      if (getEventCreatedBy) {
        eventCreatedBy = ` By ${getEventCreatedBy}`;
      }

      if (value?.event === "created") {
        if (value?.log_name == "tasks") {
          logTitle = `Task  <span class="font-weight-bolder text-primary">${value?.properties?.attributes?.title} </span> was created ${eventCreatedBy}`;
        }

        if (value?.log_name == "sub_tasks") {
          logTitle = `In this Task  <span class="font-weight-bolder text-primary">${value?.properties?.attributes?.title} </span> was added as a Sub Task ${eventCreatedBy}`;
        }

        if (value?.log_name == "linked_tasks") {
          logTitle = `Task  <span class="font-weight-bolder text-primary">${value?.properties?.attributes?.task_subtask_title} </span> was linked with this Task ${eventCreatedBy}`;
        }

        if (value?.log_name == "comments") {
          logTitle = ` <span class="font-weight-bolder text-primary">${value?.properties?.attributes?.createdBy?.name} (${value?.properties?.attributes?.createdBy?.email}) </span> commented on this Task ${eventCreatedBy}`;
        }
      }

      if (value?.event === "updated") {
        if (value?.log_name == "tasks") {
          logTitle = `Task  <span class="font-weight-bolder text-warning">${value?.properties?.attributes?.title}'s </span> information updated ${eventCreatedBy}`;
        }

        if (value?.log_name == "sub_tasks") {
          logTitle = `Sub Task  <span class="font-weight-bolder text-primary">${value?.properties?.attributes?.title} </span> was Updated ${eventCreatedBy}`;
        }

        if (value?.log_name == "comments") {
          logTitle = ` <span class="font-weight-bolder text-warning">${value?.properties?.attributes?.createdBy?.name} (${value?.properties?.attributes?.createdBy?.email}) </span> updated his previous comment on this Task ${eventCreatedBy}`;
        }
      }

      if (value?.event === "deleted") {
        if (value?.log_name == "sub_tasks") {
          logTitle = `Sub Task  <span class="font-weight-bolder text-danger">${value?.properties?.old?.title} </span> was moved to Trash ${eventCreatedBy}`;
        }

        if (value?.log_name == "linked_tasks") {
          logTitle = `Task  <span class="font-weight-bolder text-danger">${value?.properties?.old?.task_subtask_title} </span> was unlinked from this Task ${eventCreatedBy}`;
        }

        if (value?.log_name == "comments") {
          logTitle = ` <span class="font-weight-bolder text-danger">${value?.properties?.old?.createdBy?.name} (${value?.properties?.old?.createdBy?.email}) </span> deleted his comment from this Task ${eventCreatedBy}`;
        }
      }

      if (value?.log_name === "default") {
        if (value?.description == "Task Team Assign Activity Logged") {
          logTitle = `Task <span class="font-weight-bolder text-warning"> Assigned Member </span> was updated for this Task ${eventCreatedBy}`;
        }
      }

      return logTitle;
    },
    setLogVariant(value) {
      const logColors = {
        created: "primary",
        updated: "warning",
        deleted: "danger",
      };
      return logColors[value?.event] || "warning";
    },
    formatDateTime(value) {
      if (value) {
        return this.$moment(value).format("MMM Do YY, h:mm:ss a");
      }
    },

    /** Task Activity Log Section End */

    /** Task Phase Duration Log */

    formatPhaseLogTitle(value) {
      let logTitle = "";

      if (value?.event === "updated") {
        if (value?.log_name == "tasks") {
          if (
            value?.properties?.old?.phase_id !=
            value?.properties?.attributes?.phase_id
          ) {
            logTitle = `Task Moved To <span class="font-weight-bolder text-warning">${value?.properties?.attributes?.phase?.title}  </span> Phase`;
          }
        }
        if (value?.log_name == "sub_tasks") {
          if (
            value?.properties?.old?.phase_id !=
            value?.properties?.attributes?.phase_id
          ) {
            logTitle = `Sub Task Moved To <span class="font-weight-bolder text-warning">${value?.properties?.attributes?.phase?.title}  </span> Phase`;
          }
        }
      } else if (value?.event === "deleted") {
        if (value?.log_name == "tasks") {
          logTitle = `Task  <span class="font-weight-bolder text-danger">${value?.properties?.old?.title} </span> was moved to Trash `;
        }
      }

      if (value?.log_name === "default") {
        if (value?.description == "Task Team Assign Activity Logged") {
          logTitle = `Task <span class="font-weight-bolder text-warning"> Assigned Member </span> was updated for <span class="font-weight-bolder text-primary"> ${value?.properties?.task?.title} </span> Task`;
        }
      }

      return logTitle;
    },

    formatPhaseLogDescription(createdAt, endedAt) {
      let description = "";

      if (createdAt && endedAt) {
        const createdTime = this.$moment(createdAt);
        const endedTime = this.$moment(endedAt);
        const duration = endedTime.diff(createdTime);
        const durationFormatted = this.$moment.duration(duration);

        const hours = durationFormatted.hours();
        const minutes = durationFormatted.minutes();
        const seconds = durationFormatted.seconds();

        description = "Phase Duration: ";
        if (hours) {
          description = description + ` ${hours} hours`;
        }

        if (minutes) {
          description = description + ` ${minutes} minutes`;
        }

        if (seconds) {
          description = description + ` ${seconds} seconds`;
        }
      }

      return description;
    },
    /** Task Phase Duration Log End */

    checkForNextSubTask(subTask) {
      if (!subTask?.is_completed) {
        this.isNextSubTask = false;
        return true;
      }

      return false;
    },

    async onSequenceChange() {
      try {
        const subTaskIds = (this.sequencetialSubTaskList || []).map((item) => {
          return item?.id;
        });

        await this.$api.put(
          `api/milestone-task-boards/phases/tasks/${this.$route.params.id}/change-sub-task-sequence`,

          {
            sub_task_ids: subTaskIds,
          }
        );

        let foundIncomplete = false;

        (this.sequencetialSubTaskList || []).forEach((item) => {
          if (!item?.is_completed && foundIncomplete == false) {
            this.nextTask = item;
            foundIncomplete = true;
          }
        });
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Warning",
            icon: "BellIcon",
            variant: "warning",
            text: error?.response?.data?.message,
          },
        });
      }
    },
    onShowBoardDetails() {
      const id = this.task?.milestone_task_board_id;
      this.$router.push({
        name: "admin-task-board-details",
        params: { id },
      });
    },
    onShowPhase() {
      const id = this.task?.milestone_task_board_id;
      this.$router.push({
        name: "admin-task-board-phases",
        params: { id },
      });
    },

    async loadTimeDurationLog() {
      try {
        const [timeDurationLog] = await Promise.all([
          this.getBoardTimeDurationLog(),
        ]);

        this.nextPhaseChangeStartTime = [];
        this.phaseChangeLog = (timeDurationLog?.data?.data || []).filter(
          (item) =>
            item?.properties?.old?.phase_id !=
            item?.properties?.attributes?.phase_id
        );

        for (let i = 1; i < this.phaseChangeLog.length; i++) {
          this.nextPhaseChangeStartTime.push(this.phaseChangeLog[i].created_at);
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Warning",
            icon: "BellIcon",
            variant: "warning",
            text: error?.response?.data?.message,
          },
        });
      }
    },

    async loadActivityLog() {
      const [taskActivityLogs] = await Promise.all([this.getTaskActivityLog()]);

      this.taskActivityLog = taskActivityLogs?.data?.data;
    },
    async updatePhase(value) {
      try {
        const formData = new FormData();
        formData.append("_method", "PUT");

        this.taskPhaseId = value?.id;
        if (this.taskPhaseId) {
          formData.append("phase_id", this.taskPhaseId);
        }
        await this.$api.post(
          `api/milestone-task-boards/phases/tasks/${this.$route.params.id}/update-phase`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        this.loadItems();
        this.loadTimeDurationLog();
        this.taskPhaseId = "";

        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Success",
            icon: "BellIcon",
            variant: "success",
            text: "Task Phase Updated Successfully",
          },
        });
      } catch (error) {
        if (error?.response?.data?.message) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Error",
              icon: "BellIcon",
              variant: "danger",
              text: error?.response?.data?.message,
            },
          });
        }
      }
    },

    async updateSequence(value) {
      try {
        this.subTaskId = value?.id;

        const sequentialTasks = (this.subTaskList || []).filter(
          (item) => item?.sequence_num > 0
        );

        //this.subTaskId
        await this.$api.put(
          `api/milestone-task-boards/subtasks/${this.subTaskId}/update-sequence`,
          {
            sequence_num: sequentialTasks.length + 1,
          }
        );

        this.loadItems();
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Success",
            icon: "BellIcon",
            variant: "success",
            text: "Sub Task Sequence Updated Successfully",
          },
        });
      } catch (error) {
        if (error?.response?.data?.message) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Error",
              icon: "BellIcon",
              variant: "danger",
              text: error?.response?.data?.message,
            },
          });
        }
        if (error?.response?.data?.errors) {
          this.$refs.milestoneTaskBoardValidation.setErrors(
            error?.response?.data?.errors
          );
        }
      }
    },
    async resetToGeneral(id) {
      this.$swal({
        title: "Warning!",
        text: "Are You Sure You Want To Reset This To General?",
        icon: "warning",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: "Ok",
        showLoaderOnConfirm: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await this.$api.put(
              `api/milestone-task-boards/phases/tasks/${this.$route.params.id}/subtasks/change-to-general`,
              {
                sub_task_id: id,
              }
            );

            this.loadItems();

            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Success",
                icon: "BellIcon",
                variant: "success",
                text: "Sub Task Reset To General Successfully",
              },
            });
          } catch (error) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Error",
                icon: "BellIcon",
                variant: "danger",
                text: error?.response?.data?.message,
              },
            });
          }
        }
      });
    },
    async getTaskInfo() {
      return await this.$api.get(
        `api/milestone-task-boards/phases/tasks/${this.$route.params.id}?include=milestoneTaskBoard,labels,team,observer,phase,tasks,subTasks.phase,comments.createdBy,assignee`
      );
    },
    async getTaskActivityLog() {
      return await this.$api.get(
        `api/milestone-task-boards/phases/tasks/${this.$route.params.id}/activitylog`
      );
    },

    async getAllTaskInfo() {
      return await this.$api.get("api/milestone-task-boards?include=tasks");
    },

    async getBoardTimeDurationLog() {
      const milestoneTaskBoardId = this.task?.milestone_task_board_id;
      const taskId = this.$route.params.id;

      return await this.$api.get(
        `api/milestone-task-boards/${milestoneTaskBoardId}/time-duration`,
        {
          params: {
            filterTaskId: taskId,
          },
        }
      );
    },

    async loadItems() {
      try {
        const [taskInfo] = await Promise.all([this.getTaskInfo()]);

        this.task = taskInfo?.data?.data;

        console.log(this.task);

        this.taskLinkList = this.task?.links;

        this.taskDetailsPreviousFiles = (this.task?.files || []).map(
          (item) => item
        );

        // or filter short_title name to send for url

        const [allTaskInfo] = await Promise.all([this.getAllTaskInfo()]);

        this.filterAllTasksFromAllMilestone = (allTaskInfo?.data?.data || [])
          .map((item) => {
            return (item?.tasks?.data || []).map((task) => {
              return {
                id: task.id,
                shortTitle: task.short_title,
              };
            });
          })
          .flat();

        this.commentList = this.task?.comments?.data.sort((a, b) => {
          const dateA = new Date(a.created_at);
          const dateB = new Date(b.created_at);
          return dateB - dateA;
        });

        this.subTaskList = this.task?.subTasks?.data.sort((a, b) => {
          return a.sequence_num - b.sequence_num;
        });

        this.sequencetialSubTaskList = (this.subTaskList || []).filter(
          (item) => item?.sequence_num > 0
        );

        let foundIncomplete = false;

        (this.sequencetialSubTaskList || []).forEach((item) => {
          if (!item?.is_completed && foundIncomplete == false) {
            this.nextTask = item;
            foundIncomplete = true;
          }
        });

        this.generalSubTaskList = (this.subTaskList || []).filter(
          (item) => item?.sequence_num == 0
        );

        const milestoneBoardInfo = await this.$api.get(
          `/api/milestone-task-boards/${this.task?.milestone_task_board_id}?include=phases`
        );

        const milestoneTaskBoardPhases = (
          milestoneBoardInfo?.data?.data?.phases?.data || []
        ).filter((item) => item?.is_backlog == false);

        this.taskPhaseOptions = (milestoneTaskBoardPhases || []).map((item) => {
          return {
            id: item?.id,
            title: item?.title,
            isFinal: item?.is_final,
          };
        });

        // All tasks for list
        const allTasks = await this.$api.get(
          `/api/milestone-task-boards/${this.task?.milestone_task_board_id}`
        );

        let taskOptions = (allTasks?.data?.data?.tasks?.data || []).filter(
          (item) => item?.id != this.$route.params.id
        );

        this.tasksIdOption = (taskOptions || []).map((item) => {
          let name = item.title;
          return {
            name,
            id: item.id,
          };
        });

        //Filtering Duplicate Tasks
        this.tasksIdOption = this.tasksIdOption.filter((option) => {
          return !this.taskLinkList.some(
            (link) => link.task_subtask_title === option.name
          );
        });

        // Board member options

        const milestoneBoardTeamInfo = await this.getMilestoneBoardTeam(
          this.task?.milestone_task_board_id
        );

        const teamMembers = milestoneBoardTeamInfo?.data?.data?.team?.data;

        this.milestoneBoardTeamMemberIdOptions = teamMembers.map((item) => {
          return {
            avatar: item?.avatar,
            name: item?.name,
            email: item?.email,
            mobile: item?.mobile,
            employee_number: item?.employee_number,
            id: item?.id,
            departmentId: item?.department_id,
          };
        });

        // get all members
        const allMembers = await this.getAllMembers();

        this.allMemberIdOptions = allMembers?.data?.data?.map((item) => {

          const unassigned = this.milestoneBoardTeamMemberIdOptions.find(member => member.id === item?.id)

          return {
            avatar: item?.avatar,
            name: item?.name,
            email: item?.email,
            mobile: item?.mobile,
            employee_number: item?.employee_number,
            id: item?.id,
            departmentId: item?.department_id,
            inactive: !item?.status,
            unassigned: !unassigned,
          };
        }).sort((a, b) => Number(a.unassigned) - Number(b.unassigned));

      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Warning",
            icon: "BellIcon",
            variant: "warning",
            text: error?.response?.data?.message,
          },
        });
      }
    },
    onCommentDelete(id) {
      this.$swal({
        title: "Warning!",
        text: "Are You Sure You Want To Delete This Comment?",
        icon: "warning",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: "Ok",
        showLoaderOnConfirm: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await this.$api.delete(
              `api/milestone-task-boards/phases/tasks/${this.$route.params.id}/comments/${id}`
            );
            this.loadItems();

            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Success",
                icon: "BellIcon",
                variant: "success",
                text: "Comment Successfully Deleted",
              },
            });
          } catch (error) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Error",
                icon: "BellIcon",
                variant: "danger",
                text: error?.response?.data?.message,
              },
            });
          }
        }
      });
    },

    resetComment() {
      this.commentDescription = "";
      this.commentId = "";
    },
    showSubTaskForm() {
      this.isSubTaskFormLoaded = true;
    },
    closeSubTaskForm() {
      this.isSubTaskFormLoaded = false;
      this.subTaskTitle = "";
    },
    showTaskLinkForm() {
      this.isTaskLinkFormLoaded = true;
    },
    closeTaskLinkForm() {
      this.isTaskLinkFormLoaded = false;
      this.task_id = "";
    },
    async getMilestoneTaskBoardPhases() {
      const milestoneTaskBoardId = this.$route.params.id;

      return await this.$api.get(
        `/api/milestone-task-boards/${milestoneTaskBoardId}?include=phases`
      );
    },
    async getMilestoneTaskBoardPhases() {
      const milestoneTaskBoardId = this.$route.params.id;

      return await this.$api.get(
        `/api/milestone-task-boards/${milestoneTaskBoardId}?include=phases`
      );
    },

    onDeleteSubTask(id) {
      this.$swal({
        title: "Warning!",
        text: "Are You Sure You Want To Delete This Sub Task?",
        icon: "warning",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: "Ok",
        showLoaderOnConfirm: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await this.$api.delete(
              `api/milestone-task-boards/phases/tasks/subtasks/${id}`
            );
            this.loadItems();

            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Success",
                icon: "BellIcon",
                variant: "success",
                text: "Sub Task Deleted Successfully",
              },
            });
          } catch (error) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Error",
                icon: "BellIcon",
                variant: "danger",
                text: error?.response?.data?.message,
              },
            });
          }
        }
      });
    },

    onDeleteLinkTask(id) {
      this.$swal({
        title: "Warning!",
        text: "Are You Sure You Want To Move This To Trash?",
        icon: "warning",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: "Ok",
        showLoaderOnConfirm: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const taskid = this.$route.params.id;

            await this.$api.delete(
              `api/milestone-task-boards/phases/tasks/${taskid}/links/${id}`
            );
            this.loadItems();

            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Success",
                icon: "BellIcon",
                variant: "success",
                text: "Task Link Moved To Trash",
              },
            });
          } catch (error) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Error",
                icon: "BellIcon",
                variant: "danger",
                text: error?.response?.data?.message,
              },
            });
          }
        }
      });
    },

    // Show Subtask in new table
    onShowSubTask(board, taskId, task, id, subtask) {
      const routeURL = this.$router.resolve({
        name: "admin-board-task-subtask-details",
        params: { board, taskId, task, id, subtask },
      }).href;

      window.open(routeURL, "_blank");
    },

    // Task list to task page
    onShowTask(id) {
      const taskWithId = this.filterAllTasksFromAllMilestone.find(
        (task) => task.id === id
      );
      const { shortTitle } = taskWithId;

      const routeUrl = this.$router.resolve({
        name: "admin-task-board-task-details",
        params: {
          id,
          task: shortTitle,
        },
      }).href;

      const newTab = window.open(routeUrl, "_blank");
      newTab.focus();
    },

    showTaskModal(value) {
      this.showTaskModalToggleTextEditor();

      this.taskId = value?.id;
      this.title = value?.title;
      this.description = value?.description;
      this.summary = value?.summary;
      this.wordcount = value?.wordcount;
      this.sub_tasks_sum_wordcount = value?.sub_tasks_sum_wordcount;
      this.contentlink = value?.contentlink;
      this.type = value?.type;
      this.selectPriorityType = value?.priority;
      this.point = value?.point ? value?.point : "";
      this.actualStartDate = value?.actual_start_date;
      this.deadline = value?.deadline;
      this.actualEndDate = value?.actual_end_date;
      this.selectLabels = (value?.labels?.data || []).map((item) => item?.name);
      this.selectPhaseId = +value?.phase_id;
      this.previousFiles = (value?.files || []).map((item) => item);
      this.selectObserver = value?.observer_id ? +value?.observer_id : "";
      this.selectAssignee = value?.assigner_id ? +value?.assigner_id : "";

      this.$bvModal.show("modal-task-board-phase-task");
    },
    hiddenTaskModal() {
      this.$bvModal.hide("modal-task-board-phase-task");
      this.resetTaskModal();
    },
    resetTaskModal() {
      this.modelType = "";
      this.taskId = "";
      this.title = "";
      this.description = "";
      this.summary = "";
      this.wordcount = "";
      this.contentlink = "";
      this.type = "";
      this.selectPriorityType = "";
      this.selectObserver = "";
      this.selectAssignee = "";
      this.priorityOptionConstants;
      this.point = "";
      this.actualStartDate = "";
      this.deadline = "";
      this.actualEndDate = "";
      this.selectLabels = [];
      this.uploadedFiles = [];
      this.taskFiles = [];
      this.previousFiles = [];
    },
    async showAddMemberModal(value) {
      this.taskId = value?.id;

      const milestoneBoardInfo = await this.getMilestoneBoardTeam(
        value?.milestone_task_board_id
      );

      const teamMembers = milestoneBoardInfo?.data?.data?.team?.data;

      this.selectMemberIds = (value?.team?.data).map((item) => item?.id);
      this.memberIdOptions = teamMembers.map((item) => {
        return {
          avatar: item?.avatar,
          name: item?.name,
          email: item?.email,
          mobile: item?.mobile,
          employee_number: item?.employee_number,
          id: item?.id,
          departmentId: item?.department_id,
        };
      });
      this.$bvModal.show("modal-add-member-form");
    },

    async getMilestoneBoardTeam(milestoneTaskBoardId) {
      return await this.$api.get(
        `/api/milestone-task-boards/${milestoneTaskBoardId}?include=team`
      );
    },

    async getAllMembers() {
      return await this.$api.get(`api/users/all`);
    },

    hiddenAddMemberModal() {
      this.$bvModal.hide("modal-add-member-form");
      this.resetAddMemberModal();
    },
    resetAddMemberModal() {
      this.selectMemberIds = [];
    },

    subTaskAddForm: async function () {
      this.$refs.subTaskAdd.validate().then(async (success) => {
        if (success) {
          try {
            this.isSubTaskLoading = true;

            await this.$api.post(
              `/api/milestone-task-boards/phases/tasks/${this.$route.params.id}/subtasks`,
              {
                title: this.subTaskTitle,
              }
            );

            this.isSubTaskLoading = false;
            this.loadItems();
            this.loadActivityLog();
            this.closeSubTaskForm();
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Success",
                icon: "BellIcon",
                variant: "success",
                text: "Sub Task Added Successfully",
              },
            });
          } catch (error) {
            this.isSubTaskLoading = false;
            if (error?.response?.data?.message) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Error",
                  icon: "BellIcon",
                  variant: "danger",
                  text: error?.response?.data?.message,
                },
              });
            }

            if (error?.response?.data?.errors) {
              this.$refs.subTaskAdd.setErrors(error?.response?.data?.errors);
            }
          }
        }
      });
    },

    taskLinkAddForm: async function () {
      this.$refs.taskLinkAdd.validate().then(async (success) => {
        if (success) {
          try {
            this.isTaskLinkLoading = true;

            await this.$api.post(
              `/api/milestone-task-boards/phases/tasks/${this.$route.params.id}/links`,

              {
                task_subtask_id: this.task_id?.id,
                task_subtask_title: this.task_id?.name,
              }
            );

            this.isTaskLinkLoading = false;
            this.loadItems();
            this.closeTaskLinkForm();
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Success",
                icon: "BellIcon",
                variant: "success",
                text: "Task Link Added Successfully",
              },
            });
          } catch (error) {
            this.isLoading = false;
            if (error?.response?.data?.message) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Error",
                  icon: "BellIcon",
                  variant: "danger",
                  text: error?.response?.data?.message,
                },
              });
            }

            if (error?.response?.data?.errors) {
              this.$refs.backlogTask.setErrors(error?.response?.data?.errors);
            }
          }
        }
      });
    },

    taskEditForm: async function () {
      this.$refs.taskEdit.validate().then(async (success) => {
        if (success) {
          try {
            this.$refs.taskEdit.reset();
            this.isLoading = true;
            const formData = new FormData();

            formData.append("_method", "PUT");
            if (this.title) {
              formData.append("title", this.title);
            }

            if (this.description) {
              formData.append("description", this.description);
            } else {
              formData.append("description", "");
            }

            if (this.selectPhaseId) {
              formData.append("phase_id", this.selectPhaseId);
            } else {
              formData.append("phase_id", "");
            }

            if (this.type) {
              formData.append("type", this.type);
            } else {
              formData.append("type", "");
            }

            if (this.selectPriorityType) {
              formData.append("priority", this.selectPriorityType);
            } else {
              formData.append("priority", "");
            }

            if (this.selectObserver) {
              formData.append("observer_id", this.selectObserver);
            } else {
              formData.append("observer_id", "");
            }

            if (this.selectAssignee) {
              formData.append("assigner_id", this.selectAssignee);
            } else {
              formData.append("assigner_id", "");
            }

            if (this.point) {
              formData.append("point", this.point);
            } else {
              formData.append("point", "");
            }

            if (this.wordcount) {
              formData.append("wordcount", this.wordcount);
            } else {
              formData.append("wordcount", "");
            }

            if (this.contentlink) {
              formData.append("contentlink", this.contentlink);
            } else {
              formData.append("contentlink", "");
            }

            if (this.actualStartDate) {
              formData.append("actual_start_date", this.actualStartDate);
            } else {
              formData.append("actual_start_date", "");
            }

            if (this.deadline) {
              formData.append("deadline", this.deadline);
            } else {
              formData.append("deadline", "");
            }

            if (this.actualEndDate) {
              formData.append("actual_end_date", this.actualEndDate);
            } else {
              formData.append("actual_end_date", "");
            }

            this.selectLabels.forEach(function (element) {
              formData.append("labels[]", element);
            });

            this.previousFiles.forEach(function (element) {
              formData.append("previous_files[]", element.id);
            });

            this.taskFiles.forEach(function (element) {
              formData.append("files[]", element);
            });

            await this.$api.post(
              `/api/milestone-task-boards/phases/tasks/${this.taskId}`,
              formData,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              }
            );

            this.isLoading = false;
            this.loadItems();
            this.loadActivityLog();
            this.hiddenTaskModal();
            this.resetTaskModal();
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Success",
                icon: "BellIcon",
                variant: "success",
                text: "Task Information Updated Successfully",
              },
            });
            this.isLoading = false;
          } catch (error) {
            this.isLoading = false;
            if (error?.response?.data?.message) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Error",
                  icon: "BellIcon",
                  variant: "danger",
                  text: error?.response?.data?.message,
                },
              });
            }

            if (error?.response?.data?.errors) {
              this.$refs.taskEdit.setErrors(error?.response?.data?.errors);
            }
          }
        }
      });
    },

    addMemberValidationForm: async function () {
      this.$refs.addMemberValidation.validate().then(async (success) => {
        if (success) {
          try {
            this.$refs.addMemberValidation.reset();
            this.isLoading = true;

            await this.$api.post(
              `api/milestone-task-boards/tasks/${this.$route.params.id}/assign-team`,
              {
                user_ids: this.selectMemberIds,
              }
            );
            this.isLoading = false;
            this.loadItems();
            this.loadActivityLog();
            this.hiddenAddMemberModal();
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Success",
                icon: "BellIcon",
                variant: "success",
                text: "Member Added Successfully",
              },
            });
          } catch (error) {
            this.isLoading = false;
            if (error?.response?.data?.message) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Error",
                  icon: "BellIcon",
                  variant: "danger",
                  text: error?.response?.data?.message,
                },
              });
            }
            if (error?.response?.data?.errors) {
              this.$refs.milestoneTaskBoardValidation.setErrors(
                error?.response?.data?.errors
              );
            }
          }
        }
      });
    },

    addCommentForm: async function () {
      this.$refs.addCommentFormValidation.validate().then(async (success) => {
        if (success) {
          try {
            this.isLoading = true;
            await this.$api.post(
              `api/milestone-task-boards/phases/tasks/${this.$route.params.id}/comments`,
              {
                description: this.commentDescription,
              }
            );
            this.isLoading = false;
            this.loadItems();
            this.loadActivityLog();

            this.hiddenCommentModal();
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Success",
                icon: "BellIcon",
                variant: "success",
                text: "Comment Posted Successfully",
              },
            });
          } catch (error) {
            this.isLoading = false;
            if (error?.response?.data?.message) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Error",
                  icon: "BellIcon",
                  variant: "danger",
                  text: error?.response?.data?.message,
                },
              });
            }
            if (error?.response?.data?.errors) {
              this.$refs.milestoneTaskBoardValidation.setErrors(
                error?.response?.data?.errors
              );
            }
          }
        }
      });
    },

    editCommentForm: async function () {
      for (let i = 0; i < this.$refs.editCommentFormValidation.length; i++) {
        this.$refs.editCommentFormValidation[i]
          .validate()
          .then(async (success) => {
            if (success) {
              try {
                this.isLoading = true;
                await this.$api.put(
                  `api/milestone-task-boards/phases/tasks/${this.$route.params.id}/comments/${this.commentId}`,
                  {
                    description: this.commentDescription,
                  }
                );
                this.isLoading = false;
                this.loadItems();
                this.loadActivityLog();

                this.hiddenEditCommentModal();
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "Success",
                    icon: "BellIcon",
                    variant: "success",
                    text: "Comment Edited Successfully",
                  },
                });
              } catch (error) {
                this.isLoading = false;
                if (error?.response?.data?.message) {
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: "Error",
                      icon: "BellIcon",
                      variant: "danger",
                      text: error?.response?.data?.message,
                    },
                  });
                }
                if (error?.response?.data?.errors) {
                  this.$refs.milestoneTaskBoardValidation.setErrors(
                    error?.response?.data?.errors
                  );
                }
              }
            }
          });
      }
    },
    toggleFullscreen() {
      this.isFullscreen = !this.isFullscreen;
    }
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/quill.scss";

.suggestion-button-position {
  margin-left: 10px;
  margin-top: 5px;
}
.title-width {
  width: 320px;
}
.input-loader {
  position: absolute;
  right: 15px;
  margin-right: 15px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
  margin-top: 15px;
}

.input-loader-des {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
}

.button-icon {
  padding: 3px !important;
}
.hover-effect {
  transition: all 0.3s ease-in-out;
  position: relative;
}

.hover-effect:hover {
  background-color: #007bff; /* Change the background color */
  color: white; /* Change the text/icon color */
  transform: scale(1.1); /* Slight zoom effect */
}

.hover-effect svg {
  transition: transform 0.3s ease-in-out;
}

.hover-effect:hover svg {
  transform: rotate(20deg) scale(1.2); /* Add rotation and scale to the SVG icon */
}

.custom-font {
  font-size: 11px !important;
}

.label-margin {
  margin-top: 8px;
  margin-right: 8px;
}

.table-custom-style {
  font-size: 13px !important;
  white-space: nowrap !important;
  min-height: 140px !important;
  tr,
  th,
  td {
    vertical-align: left !important;
    text-align: left !important;
  }
}
.custom-font {
  font-size: 13px !important;
}

.file-input {
  display: inline-block;
  position: relative;
}

.attach-icon {
  display: inline-block;
  padding: 5px 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  background-color: #f0f0f0;
  cursor: pointer;
}

.uploaded-files {
  margin-top: 20px;
}

.file-preview {
  display: inline-block;
  margin-right: 10px;
}
.file-preview .bigger-icon {
  font-size: 50px;
  color: #999;
}
.button-padding {
  padding-bottom: 15px;
}

.log-scrollable {
  max-height: 500px;
  overflow-y: auto;
}
.comment-scrollable {
  max-height: 700px;
  overflow-y: auto;
  overflow-x: hidden;
}

.dropdown button {
  padding: 5px 6px;
}

.sequencial-sub-task-list .list-group-flush > .list-group-item {
  border-width: thin;
  border-bottom-width: 0px;
}
.sequencial-sub-task-list .list-group-flush > .list-group-item:last-child {
  border-bottom-width: thin;
}
.list-group-item {
  transition: all 2s;
}
.required-label label::after {
  content: " *";
  color: red;
}

/* Fullscreen mode */
.fullscreen {
  position: fixed !important;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: white;
  z-index: 9999;
  padding: 10px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

/* Adjust editor and toolbar in fullscreen mode */
.fullscreen .ql-container {
  height: calc(100vh - 50px) !important;
}

.fullscreen .ql-toolbar {
  position: sticky;
  top: 0;
  background: white;
  z-index: 1000;
  padding: 10px;
}

/* Fullscreen button styling */
.fullscreen-btn {
  border: none;
  background: none;
  cursor: pointer;
  font-size: 18px;
  margin-left: 10px;
}
</style>
